module.exports = __webpack_public_path__ + "static/media/hall-PI.5fcc0150.svg";